var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"color":"black","icon":"","x-large":""},on:{"click":function($event){_vm.isMain
        ? _vm.$router.push({ name: 'home' })
        : _vm.checkBack
        ? _vm.$router.push({ name: 'mobile_attraction' })
        : _vm.$router.push({ name: 'mobile_citypass' })}}},[_c('v-row',{attrs:{"no-gutters":"","justify":"center","align":"center"}},[_c('v-col',{staticClass:"col-12 pa-0"},[_c('img',{attrs:{"src":require("@/assets/mobileBackButton.svg")}})])],1)],1),_c('attraction-detail-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }